import { render } from "./SitePlanOpportunitiesComponent.vue?vue&type=template&id=8e0268d8"
import script from "./SitePlanOpportunitiesComponent.vue?vue&type=script&lang=js"
export * from "./SitePlanOpportunitiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__